<nav class="floating-nav" aria-label="Quick actions">
  <button type="button" class="nav-item" aria-label="Get Inquiry" (click)="openDrawer()">
    <span class="nav-content"><i class="bi bi-chat-dots-fill" aria-hidden="true"></i></span>
    <span class="nav-label">Get Inquiry</span>
  </button>

  <a
    href="https://hpimarketplace.com/"
    target="_blank"
    rel="noopener noreferrer"
    class="nav-item"
    aria-label="Marketplace"
  >
    <span class="nav-content"><i class="bi bi-cart-fill" aria-hidden="true"></i></span>
    <span class="nav-label">Marketplace</span>
  </a>
</nav>

@if (inquiryDrawer.isOpen()) {
<div class="inquiry-overlay" role="presentation" (mousedown)="closeDrawer()">
  <aside
    class="inquiry-drawer"
    role="dialog"
    aria-modal="true"
    aria-labelledby="inquiry-drawer-title"
    (mousedown)="$event.stopPropagation()"
  >
    <header class="inquiry-header">
      <div>
        <span class="inquiry-eyebrow">Talk to Hytec</span>
        <h2 id="inquiry-drawer-title">How can we help?</h2>
        <p>Tell us what you need and our team will respond using your preferred contact details.</p>
      </div>
      <button
        #drawerCloseButton
        type="button"
        class="inquiry-close"
        aria-label="Close inquiry form"
        [disabled]="isSubmitting"
        (click)="closeDrawer()"
      >
        <i class="bi bi-x-lg" aria-hidden="true"></i>
      </button>
    </header>

    <div class="inquiry-scroll-area">
      <form class="inquiry-form" [formGroup]="inquiryForm" (ngSubmit)="submitInquiry()" novalidate>
        <div class="inquiry-section">
          <div class="inquiry-grid">
            <div class="inquiry-field">
              <label for="inquiry-name">Name <span>*</span></label>
              <input
                id="inquiry-name"
                type="text"
                formControlName="name"
                autocomplete="name"
                maxlength="50"
                placeholder="Your full name"
                [class.is-invalid]="showFieldError('name')"
                [attr.aria-invalid]="showFieldError('name')"
                [attr.aria-describedby]="fieldDescribedBy('name')"
              />
              @if (showFieldError('name')) {
                <small id="inquiry-name-error">{{ fieldError('name') }}</small>
              }
            </div>

            <div class="inquiry-field">
              <label for="inquiry-email">Email <span>*</span></label>
              <input
                id="inquiry-email"
                type="email"
                formControlName="email"
                autocomplete="email"
                maxlength="50"
                placeholder="name@company.com"
                [class.is-invalid]="showFieldError('email')"
                [attr.aria-invalid]="showFieldError('email')"
                [attr.aria-describedby]="fieldDescribedBy('email')"
              />
              @if (showFieldError('email')) {
                <small id="inquiry-email-error">{{ fieldError('email') }}</small>
              }
            </div>
          </div>

          <div class="inquiry-grid">
            <div class="inquiry-field">
              <label for="inquiry-phone">Contact number <span>*</span></label>
              <input
                id="inquiry-phone"
                type="tel"
                formControlName="phone"
                autocomplete="tel"
                maxlength="20"
                placeholder="+63 917 123 4567"
                [class.is-invalid]="showFieldError('phone')"
                [attr.aria-invalid]="showFieldError('phone')"
                [attr.aria-describedby]="fieldDescribedBy('phone')"
              />
              @if (showFieldError('phone')) {
                <small id="inquiry-phone-error">{{ fieldError('phone') }}</small>
              }
            </div>

            <div class="inquiry-field">
              <label for="inquiry-organization">Company or school <span>*</span></label>
              <input
                id="inquiry-organization"
                type="text"
                formControlName="organization"
                autocomplete="organization"
                maxlength="50"
                placeholder="Company or school name"
                [class.is-invalid]="showFieldError('organization')"
                [attr.aria-invalid]="showFieldError('organization')"
                [attr.aria-describedby]="fieldDescribedBy('organization')"
              />
              @if (showFieldError('organization')) {
                <small id="inquiry-organization-error">{{ fieldError('organization') }}</small>
              }
            </div>
          </div>
        </div>

        <div class="inquiry-section">
          <div class="inquiry-field">
            <label for="inquiry-type">Inquiry type <span>*</span></label>
            <select
              id="inquiry-type"
              formControlName="inquiryType"
              [class.is-invalid]="showFieldError('inquiryType')"
              [attr.aria-invalid]="showFieldError('inquiryType')"
              [attr.aria-describedby]="fieldDescribedBy('inquiryType')"
            >
              <option value="">Select an inquiry type</option>
              @for (inquiryType of inquiryTypes; track inquiryType) {
                <option [value]="inquiryType">{{ inquiryType }}</option>
              }
            </select>
            @if (showFieldError('inquiryType')) {
              <small id="inquiry-inquiryType-error">{{ fieldError('inquiryType') }}</small>
            }
          </div>

          @if (inquiryForm.controls.inquiryType.value === 'Other') {
          <div class="inquiry-field inquiry-conditional-field">
            <label for="inquiry-other-type">Please specify <span>*</span></label>
            <input
              id="inquiry-other-type"
              type="text"
              formControlName="otherInquiryType"
              maxlength="100"
              placeholder="What would you like to inquire about?"
              [class.is-invalid]="showFieldError('otherInquiryType')"
              [attr.aria-invalid]="showFieldError('otherInquiryType')"
              [attr.aria-describedby]="fieldDescribedBy('otherInquiryType')"
            />
            @if (showFieldError('otherInquiryType')) {
              <small id="inquiry-otherInquiryType-error">
                {{ fieldError('otherInquiryType') }}
              </small>
            }
          </div>
          }

          <div class="inquiry-field">
            <div class="inquiry-label-row">
              <label for="inquiry-message">Message <span>*</span></label>
              <span>{{ inquiryForm.controls.message.value?.length || 0 }}/1000</span>
            </div>
            <textarea
              id="inquiry-message"
              formControlName="message"
              rows="5"
              minlength="10"
              maxlength="1000"
              placeholder="Include the product, training, service, or concern you want us to assist with."
              [class.is-invalid]="showFieldError('message')"
              [attr.aria-invalid]="showFieldError('message')"
              [attr.aria-describedby]="fieldDescribedBy('message')"
            ></textarea>
            @if (showFieldError('message')) {
              <small id="inquiry-message-error">{{ fieldError('message') }}</small>
            }
          </div>

          <div class="inquiry-context">
            <i class="bi bi-link-45deg" aria-hidden="true"></i>
            <span>Current page included automatically.</span>
          </div>
        </div>

        <label class="inquiry-consent" [class.has-error]="showFieldError('privacyConsent')">
          <input type="checkbox" formControlName="privacyConsent" />
          <span>
            I agree that Hytec Power may use these details to respond to my inquiry. See the
            <a routerLink="/privacy-policy" (click)="closeDrawer()">Privacy Policy</a>.
          </span>
        </label>
        @if (showFieldError('privacyConsent')) {
          <small class="inquiry-consent-error">{{ fieldError('privacyConsent') }}</small>
        }

        <button
          type="submit"
          class="inquiry-submit"
          [disabled]="inquiryForm.invalid || isSubmitting"
        >
          <span>{{ isSubmitting ? 'Sending inquiry...' : 'Send inquiry' }}</span>
          <i class="bi bi-arrow-right" aria-hidden="true"></i>
        </button>
      </form>

      <section class="inquiry-alternatives" aria-labelledby="inquiry-contact-options">
        <h3 id="inquiry-contact-options">Prefer to contact us directly?</h3>
        <div class="inquiry-contact-grid">
          <a href="tel:+63270065435"><i class="bi bi-telephone-fill"></i><span>Call us</span></a>
          <a href="mailto:training@hytecpower.com"
            ><i class="bi bi-envelope-fill"></i><span>Email</span></a
          >
          <a href="https://wa.me/639178145082" target="_blank" rel="noopener noreferrer"
            ><i class="bi bi-whatsapp"></i><span>WhatsApp</span></a
          >
          <a href="viber://chat?number=%2B639178145082"
            ><i class="bi bi-chat-fill"></i><span>Viber</span></a
          >
        </div>
        <a class="inquiry-contact-page" routerLink="/company/our-contacts" (click)="closeDrawer()">
          View all Hytec contact details <i class="bi bi-arrow-right" aria-hidden="true"></i>
        </a>
      </section>
    </div>
  </aside>
</div>
}
